import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UrlParamsProcessor } from 'listeners/UrlParamsProcessor';
import AppNavigationRouter from 'navigation/AppNavigationRouter';
import { AppThemeProvider } from 'providers/AppThemeProvider/AppThemeProvider';
import { HtmlThemeProvider } from 'providers/HtmlThemeProvider/HtmlThemeProvider';
import { ToastProvider } from 'providers/ToastProvider/ToastProvider';
import { useHandleLoadingScreenState } from 'utils/hooks/useHandleLoadingScreenState';
import useModalObserver from 'utils/hooks/useModalObserver';
import usePreventScrollOnFocusedNumberInput from 'utils/hooks/usePreventScrollOnFocusedNumberInput';
import { setIsExternalHost } from 'store/Common/actions/common';
import { RootState } from 'store/store';
import { isExternalHost } from 'utils/hostUtils';

function App() {
  const dispatch = useDispatch();
  const isExternalHostState = useSelector(
    (state: RootState) => state.commonInfo.isExternalHost
  );

  useEffect(() => {
    const shouldBeExternalHost = isExternalHost(window.location.hostname);
    if (isExternalHostState !== shouldBeExternalHost) {
      dispatch(setIsExternalHost(shouldBeExternalHost));
    }
  }, [dispatch, isExternalHostState]);

  useModalObserver();
  useHandleLoadingScreenState();
  usePreventScrollOnFocusedNumberInput();

  return (
    <UrlParamsProcessor>
      <AppThemeProvider>
        <HtmlThemeProvider>
          <ToastProvider>
            <AppNavigationRouter />
          </ToastProvider>
        </HtmlThemeProvider>
      </AppThemeProvider>
    </UrlParamsProcessor>
  );
}

export default App;
